var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRmisInctive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25216 18.7176C10.1174 16.2562 13.2263 9.57072 22 3.75C14.9534 4.84762 9.32297 12.0321 8.01036 13.8282C6.69775 12.0653 4.10708 10.1694 2 9.90333C3.38169 10.9344 6.03109 14.8792 8.25216 18.7176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.102 2C11.102 2 13.3403 4.83386 19.0156 4.59105C12.6253 7.35506 8.0381 13.8077 8.0381 13.8077C5.90684 11.22 3.70995 10.3419 2.73586 10.0559C2.66332 8.22485 2.79803 6.39132 3.13655 4.58773C8.84985 4.85049 11.102 2 11.102 2Z",
    fill: "url(#paint0_radial_1476_92084)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.986 3.75977C21.005 4.76176 20.1337 5.85855 19.385 7.03267C20.094 14.4566 17.3306 19.4458 11.0948 22.0002C5.93161 19.8848 3.15355 16.0872 2.75977 10.6083C4.48688 12.4044 6.04474 14.7659 8.26236 18.6874C12.2485 11.8855 17.1708 6.71004 21.986 3.75977Z",
    fill: "url(#paint1_radial_1476_92084)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1573 6.89557L19.1089 6.96875V7.05523C19.178 7.7903 19.216 8.5154 19.216 9.20391C19.216 11.9247 18.6702 14.2862 17.5994 16.2254C17.4155 16.5513 17.2186 16.8673 17.0087 17.1733C15.7376 15.5119 14.3524 13.9345 12.8636 12.4502C15.0407 9.67788 17.5968 7.20158 20.463 5.08949C20.0726 5.58175 19.6167 6.19043 19.1573 6.89557ZM9.19871 9.1008C9.69612 9.51989 10.1797 9.93981 10.6495 10.3614C12.425 8.53203 14.9327 6.34344 17.8757 4.84668C13.8101 4.73359 11.7617 3.06388 11.102 2.38867C10.387 3.12375 8.10371 4.97972 3.43359 4.85001C5.44741 6.14719 7.37314 7.56662 9.19871 9.1008Z",
    fill: "url(#paint2_linear_1476_92084)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1476_92084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.93793 1.30151) scale(9.41969 9.07035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#62B91E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A7226"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1476_92084",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.2399 12.1616) scale(8.12435 7.82305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#42515F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1476_92084",
    x1: 7.62876,
    y1: 0.810425,
    x2: 20.3172,
    y2: 13.9875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRmisInctive);
export default __webpack_public_path__ + "static/media/rmisInctive.e33f5d234e7459d37c8891737091eb60.svg";
export { ForwardRef as ReactComponent };